import { parseDateTz } from "@mgdx/shared/src/utils/parseDateTz";
import { Text } from "@mgdx/ui/components/Text";
import clsx from "clsx";

import { TalkMessageDocument } from "../../models/TalkMessageDocument";
import mainStyles from "./index.module.css";
import styles from "./SentMessage.module.css";
import { TalkMessageImage } from "./TalkMessageImage";

export type SentMessageProps = {
  message: TalkMessageDocument;
  isFirstMessage?: boolean;
  isLastMessage?: boolean;
  isUnread?: boolean;
};

export const SentMessage = ({ message, isUnread, isFirstMessage, isLastMessage, ...props }: SentMessageProps) => {
  return (
    <div
      className={clsx(
        styles.sentMessage,
        isFirstMessage && mainStyles.isFirstMessage,
        isFirstMessage && styles.isFirstMessage,
        isLastMessage && styles.isLastMessage
      )}
    >
      <div className={styles.content}>
        {message.body.image ? (
          <TalkMessageImage image={message.body.image} />
        ) : (
          <div className={clsx(mainStyles.balloon, styles.balloon)}>
            <Text>{message.body.content}</Text>
          </div>
        )}
      </div>

      {isLastMessage && (
        <div className={clsx(mainStyles.timestamp, styles.timestamp)}>
          {!isUnread && "既読・"}
          {parseDateTz(message.sentAt)?.format("HH:mm")}
        </div>
      )}
    </div>
  );
};
